import { ESortOrder, } from "@domains/features/Markets/MutualFunds/dto/MutualFundsSchemesDTO";
export var EFundTabs;
(function (EFundTabs) {
    EFundTabs["EQUITY"] = "equity";
    EFundTabs["HYBRID"] = "hybrid";
    EFundTabs["TAX"] = "tax-saving";
})(EFundTabs || (EFundTabs = {}));
// export interface IDefaultMutualFundFilterConfig {Record<string,any>}
export var FilterSortList = [
    { name: "Name - A to Z", value: "Name", type: ESortOrder.ASCENDING },
    { name: "Name - Z to A", value: "NameDSC", type: ESortOrder.DESCENDING },
    {
        name: "1 Year CAGR Returns - High to Low",
        value: "Year1",
        type: ESortOrder.DESCENDING,
    },
    {
        name: "3 Year CAGR Returns - High to Low",
        value: "Year3",
        type: ESortOrder.DESCENDING,
    },
    {
        name: "5 Year CAGR Returns - High to Low",
        value: "Year5",
        type: ESortOrder.DESCENDING,
    },
    {
        name: "AUM - Highest to Lowest",
        value: "FundSize",
        type: ESortOrder.DESCENDING,
    },
];
export var MappingSortVal = {
    Name: "name",
    Year1: "year1",
    Year3: "year3",
    Year5: "year5",
    Rating: "rating",
    FundSize: "aum",
    ExpenseRatio: "expenseRatio",
};
export var defaultMutualFundFilterConfig = {
    "tax savings": {
        subCatCode: ["11"],
    },
};
